export default __webpack_public_path__ + "static/withdrawal_form-e9fe0f13372a024299ba40b1919c7990.pdf";